/**
 * Get the time and date in numeric form e.g. "09/04/1986 8:30 PM EST".
 *
 * @param params.timeZone - The time zone to apply
 * @param [params.locale] - The locale to apply
 */
export function dateTimeFormatNumeral(
  date: Date | number,
  options?: {
    twentyFourHour?: boolean;
    seconds?: boolean;
    timeZone?: string;
    locale?: string;
  },
): string {
  const formatter = new Intl.DateTimeFormat(options?.locale, {
    timeZone: options?.timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: options?.seconds ? 'numeric' : undefined,
    hourCycle: options?.twentyFourHour ? 'h24' : undefined,
    timeZoneName: 'short',
  });

  return formatter.format(new Date(date));
}

/**
 * Get the time in numeric form e.g. "8:30 PM EST".
 *
 * @param params.timeZone - The time zone to apply
 * @param [params.locale] - The locale to apply
 */
export function timeFormatNumeral(
  date: Date | number,
  options?: {
    twentyFourHour?: boolean;
    seconds?: boolean;
    timeZone?: string;
    locale?: string;
    hideTimeZone?: boolean;
  },
): string {
  const formatter = new Intl.DateTimeFormat(options?.locale, {
    timeZone: options?.timeZone,
    hour: 'numeric',
    minute: 'numeric',
    second: options?.seconds ? 'numeric' : undefined,
    hourCycle: options?.twentyFourHour ? 'h24' : undefined,
    timeZoneName: options?.hideTimeZone ? undefined : 'short',
  });

  return formatter.format(new Date(date));
}

export function dateTimeFormatMMMDDYYYY(
  date: Date | number,
  options?: {
    twentyFourHour?: boolean;
    seconds?: boolean;
    timeZone?: string;
    locale?: string;
  },
): string {
  const month = new Intl.DateTimeFormat(options?.locale, { month: 'short' }).format(new Date(date));
  const day = new Intl.DateTimeFormat(options?.locale, { day: '2-digit' }).format(new Date(date));
  const year = new Intl.DateTimeFormat(options?.locale, { year: 'numeric' }).format(new Date(date));
  const time = timeFormatNumeral(date, options);
  return `${month} ${day}, ${year} ${time}`;
}
